import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-6 bg-dark border-y border-gold/10" data-id="element-24">
      <div className="max-w-3xl mx-auto text-center" data-id="element-25">
        <FadeIn data-id="element-26">
          {/* Satisfaction Shield Badge */}
          <div className="relative inline-flex items-center justify-center mb-8" data-id="element-27">
            <div className="absolute inset-0 bg-gold/20 blur-2xl rounded-full" data-id="element-28"></div>
            <div className="relative w-32 h-32 rounded-full bg-gradient-to-br from-gold/10 to-transparent border-2 border-gold/40 flex items-center justify-center shadow-[0_0_30px_rgba(212,175,55,0.25)]" data-id="element-29">
              <ShieldCheck className="w-16 h-16 text-gold drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-30" />
            </div>
          </div>

          <p className="text-gold tracking-[0.25em] text-xs md:text-sm uppercase font-semibold mb-3" data-id="element-31">
            Satisfaction Shield
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-32">
            7-Day Ironclad Guarantee
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-33">
            Try it for 7 days. If you don’t feel your energy increasing, if you
            don’t see results in your confidence, or if you simply don’t like
            the design, I will refund 100% of your money. No questions asked.
            The risk is all mine.
          </p>
        </FadeIn>
      </div>
    </section>;
}